export const COMPANY_DATA = {
  Anthropic: 'https://exponent-static.s3.us-east-1.amazonaws.com/company_logos/anthropic-long.png',
  Meta: '/images/companies/meta.png',
  Google: '/images/companies/google.png',
  Microsoft: '/images/companies/microsoft.png',
  Amazon: '/images/companies/amazon.png',
  OpenAI: 'https://exponent-static.s3.us-east-1.amazonaws.com/company_logos/openai-long.png',
  NVIDIA: 'https://exponent-static.s3.us-east-1.amazonaws.com/company_logos/nvidia-long.png',
  Airbnb: '/images/companies/airbnb.png',
  TikTok: '/images/companies/tiktok.png',
  Stripe: '/images/companies/stripe.png',
  Facebook: '/images/companies/meta.png',
  Linkedin: '/images/companies/linkedin.png',
  Uber: '/images/companies/uber.webp',
  Spotify: '/images/companies/spotify.png',
  Doordash: '/images/companies/doordash.png',
  Apple: '/images/companies/apple.png',
  'Google-cloud': 'https://exponent-static.s3.amazonaws.com/company_logos/google.png',
  Netflix: 'https://exponent-static.s3.amazonaws.com/company_logos/netflix.png',
  Adobe: 'https://exponent-static.s3.amazonaws.com/company_logos/adobe.png',
  Lyft: 'https://exponent-static.s3.amazonaws.com/company_logos/lyft.png',
  Walmart: 'https://exponent-static.s3.amazonaws.com/company_logos/walmart.png',
  Tesla: 'https://exponent-static.s3.amazonaws.com/company_logos/tesla.png',
  Salesforce: 'https://exponent-static.s3.amazonaws.com/company_logos/salesforce.png',
  Coinbase: 'https://exponent-static.s3.amazonaws.com/company_logos/coinbase.png',
  Discord: 'https://exponent-static.s3.amazonaws.com/company_logos/discord.png',
  JPMorgan: 'https://exponent-static.s3.amazonaws.com/company_logos/jp-morgan-long.png',
  Citi: 'https://exponent-static.s3.amazonaws.com/company_logos/citi-group.png',
  'Morgan Stanley': 'https://exponent-static.s3.amazonaws.com/company_logos/morgan-stanley.png',
  'Bank of America': 'https://exponent-static.s3.amazonaws.com/company_logos/bank-of-america.png',
  'Deutsche Bank': 'https://exponent-static.s3.us-east-1.amazonaws.com/company_logos/deutsche-bank.png',
  Barclays: 'https://exponent-static.s3.us-east-1.amazonaws.com/company_logos/barclays.png',
  UBS: 'https://exponent-static.s3.amazonaws.com/company_logos/ubs-long.png',
  PJT: 'https://exponent-static.s3.amazonaws.com/company_logos/pjt.png',
  Palantir: 'https://exponent-static.s3.amazonaws.com/company_logos/palantir-long.png',
  Databricks: 'https://exponent-static.s3.amazonaws.com/company_logos/databricks-long.png',
};

export const FALLBACK_COMPANY_IDS = ['Meta', 'Google', 'Microsoft', 'Amazon', 'OpenAI', 'Airbnb', 'TikTok', 'Stripe'];

// Output by scripts/generate_top_companies_by_course.js
export const TOP_COMPANIES_BY_CONTENT = {
  algorithms: [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'amazon-leadership-principles': [
    'Anthropic',
    'Amazon',
    'Google',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'amazon-pm-overview': [
    'Anthropic',
    'Amazon',
    'Google',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  analytical: [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'analytical-problem-solving': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
  ],
  'app-critique': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
  ],
  arrays: [
    'Anthropic',
    'Apple',
    'Microsoft',
    'OpenAI',
    'Linkedin',
    'Facebook',
    'Google',
    'Amazon',
  ],
  'aws-sa-intro': [
    'Anthropic',
    'Amazon',
    'Google',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
  ],
  behavioral: [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'behavioral-bizops': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'behavioral-interviews-for-pms': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'bizops-data': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'bizops-intro': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'break-into-fintech': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'common-pmm': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Spotify',
  ],
  'conduct-uer': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'cross-functional-pmm': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'cross-functional-tpm': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'data-analyst-introduction': [
    'Anthropic',
    'Facebook',
    'Google',
    'OpenAI',
    'Amazon',
    'Uber',
    'Doordash',
    'Microsoft',
  ],
  'data-analyst-technical': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Doordash',
    'Microsoft',
  ],
  'data-analytics-behavioral': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Doordash',
    'Apple',
  ],
  'data-analytics-introduction': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Apple',
    'Uber',
  ],
  'data-analytics-take-home-case-studies': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Uber',
    'Apple',
  ],
  'data-analytics-technical': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Apple',
    'Uber',
  ],
  'data-communications-questions': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
  ],
  'data-engineering-intro': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Apple',
    'Uber',
  ],
  'data-engineer-sql-review-test': [
    'Anthropic',
    'Google',
    'Microsoft',
    'OpenAI',
    'Facebook',
    'Apple',
    'Amazon',
    'Linkedin',
  ],
  'data-modeling-interviews': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Apple',
    'Uber',
  ],
  'data-pipeline-design-interviews': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Apple',
    'Uber',
  ],
  'data-science': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Apple',
    'Uber',
  ],
  'data-science-interview-practice': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Linkedin',
    'Microsoft',
    'Doordash',
  ],
  'data-scientist-introduction': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Apple',
    'Uber',
  ],
  'data-structures': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'design-challenges': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'design-run-experiments': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'dynamic-programming': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Linkedin',
    'Amazon',
    'Uber',
    'Microsoft',
  ],
  'em-intro': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  estimation: [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  execution: [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'facebook-pm-overview': [
    'Anthropic',
    'Facebook',
    'Google',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'favorite-product': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'forward-deployed-engineering': [
    'Anthropic',
    'OpenAI',
    'Google',
    'Palantir',
    'Amazon',
    'Databricks',
    'Salesforce',
    'Microsoft',
  ],
  'fundamentals-analytics': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'fundamentals-system-design': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  gamestop: [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Uber',
    'Facebook',
    'Linkedin',
    'Microsoft',
  ],
  'general-interview': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'get-the-interview': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
  ],
  'google-collaboration': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
  ],
  'google-craft-execution': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
  ],
  'google-pm-overview': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'graphs-and-trees': [
    'Anthropic',
    'Google',
    'Microsoft',
    'OpenAI',
    'Amazon',
    'Facebook',
    'Uber',
    'Linkedin',
  ],
  'hash-tables': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  heaps: [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Apple',
    'Linkedin',
    'Walmart-labs',
  ],
  'introduction-to-security-engineering': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Apple',
    'Linkedin',
  ],
  'investment-banking': [
    'JPMorgan',
    'Citi',
    'Morgan Stanley',
    'Bank of America',
    'Deutsche Bank',
    'Barclays',
    'UBS',
    'PJT',
  ],
  'ib-fast-track': [
    'JPMorgan',
    'Citi',
    'Morgan Stanley',
    'Bank of America',
    'Deutsche Bank',
    'Barclays',
    'UBS',
    'PJT',
  ],
  'machine-learning': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'marketing-case': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
  ],
  'marketing-strategy': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
  ],
  'ml-coding': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Apple',
    'Linkedin',
  ],
  'ml-coding-data-scientist-questions': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Apple',
    'Uber',
  ],
  'ml-concepts-interviews': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
  ],
  'ml-concepts-questions': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
  ],
  'ml-concepts-questions-data-scientists': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
  ],
  'ml-engineer-intro': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
  ],
  'ml-system-design': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
  ],
  'ml-system-design-questions': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Apple',
    'Linkedin',
  ],
  'people-management': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  pm: [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'pm-intro': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  pmm: [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Spotify',
  ],
  'pm-product-design': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
  ],
  'product-sense': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
  ],
  'pm-skills': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'pm-technical': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'portfolio-review': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Spotify',
  ],
  'preview-system-design-questions': [
    'Anthropic',
    'Facebook',
    'Amazon',
    'OpenAI',
    'Doordash',
    'Google',
    'Microsoft',
  ],
  'product-designer-intro': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
  ],
  'product-sense-case-studies-questions': [
    'Anthropic',
    'Facebook',
    'Google',
    'OpenAI',
    'Amazon',
    'Apple',
    'Microsoft',
    'Uber',
  ],
  'product-strategy': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'program-sense': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'project-mgmt-bizops': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'project-retro': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'python-array-practice': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Apple',
    'Linkedin',
  ],
  'python-coding-data-scientist-questions': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
  ],
  'python-data-and-machine-learning': [
    'Anthropic',
    'Facebook',
    'Google',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
  ],
  'python-graphs-and-trees-practice': [
    'Anthropic',
    'Amazon',
    'Google',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Apple',
    'Linkedin',
  ],
  'python-linked-list-practice': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Apple',
    'Linkedin',
  ],
  'python-ml-system-design': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Apple',
    'Linkedin',
  ],
  'python-string-practice': [
    'Anthropic',
    'Facebook',
    'Google',
    'OpenAI',
    'Microsoft',
    'Stripe',
    'Apple',
    'Linkedin',
  ],
  'recursion-and-backtracking': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Apple',
    'Linkedin',
  ],
  'sa-customer-interaction': [
    'Anthropic',
    'Amazon',
    'Google',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
  ],
  'sa-intro': [
    'Anthropic',
    'Amazon',
    'Google',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
  ],
  'sa-technical': [
    'Anthropic',
    'Amazon',
    'Google',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
  ],
  'searching-and-sorting': [
    'Anthropic',
    'Google',
    'Microsoft',
    'OpenAI',
    'Apple',
    'Amazon',
    'Linkedin',
    'Facebook',
  ],
  'security-engineering-mock-interviews': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Apple',
  ],
  'security-principles': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Apple',
    'Linkedin',
  ],
  'software-engineering': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'solutions-architect-behavioral': [
    'Anthropic',
    'Amazon',
    'Google',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
  ],
  'sql-foundations': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
  ],
  'sql-interview-questions': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
  ],
  'sql-interviews': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
  ],
  'sql-practice-questions': [
    'Anthropic',
    'Facebook',
    'Google',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Apple',
    'Linkedin',
  ],
  'stacks-and-queues': [
    'Anthropic',
    'Google',
    'Lyft',
    'OpenAI',
    'Apple',
    'Facebook',
    'Linkedin',
    'Microsoft',
  ],
  'stakeholder-management-bizops': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'statistics-experimentation-questions': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Apple',
    'Uber',
  ],
  'strategic-decisions-bizops': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'string-manipulation': [
    'Anthropic',
    'Google',
    'Apple',
    'OpenAI',
    'Microsoft',
    'Linkedin',
    'Spotify',
    'Google-cloud',
  ],
  'swe-behavioral': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'swe-intro': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
  ],
  'swe-practice': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Uber',
    'Linkedin',
  ],
  'system-design': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'system-design-interviews': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Apple',
    'Uber',
  ],
  'take-home': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
  ],
  'technical-basics-pm': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'tech-salary-offer-negotiation': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Apple',
  ],
  tpm: [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'tpm-intro': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  undefined: [
    'Anthropic',
    'Google',
    'Microsoft',
    'OpenAI',
    'Facebook',
    'Amazon',
    'Uber',
    'Linkedin',
  ],
  'user-insight': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
  ],
  'amazon-interview': [
    'Anthropic',
    'Amazon',
    'Google',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'amazon-sde-interview': [
    'Anthropic',
    'Amazon',
    'Google',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Uber',
    'Linkedin',
  ],
  'amazon-sdm-interview': [
    'Anthropic',
    'Amazon',
    'Google',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'amazon-solution-architect-interview': [
    'Anthropic',
    'Amazon',
    'Google',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
  ],
  bizops: [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
  ],
  'data-analyst': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Doordash',
    'Uber',
  ],
  'data-analytics': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Apple',
    'Uber',
  ],
  'data-engineering': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Apple',
    'Uber',
  ],
  'data-science-interview': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'data-scientist': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Apple',
  ],
  'engineering-management': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'facebook-pm-interview': [
    'Anthropic',
    'Facebook',
    'Google',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
  'google-pm-interview': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
  ],
  'ml-engineer': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Apple',
    'Uber',
  ],
  'product-designer-interview': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Microsoft',
    'Amazon',
    'Linkedin',
    'Uber',
  ],
  'python-developer-interviews': [
    'Anthropic',
    'Amazon',
    'Facebook',
    'OpenAI',
    'Google',
    'Microsoft',
    'Apple',
    'Linkedin',
  ],
  'python-developer-interviews-test': [
    'Anthropic',
    'Google',
    'Apple',
    'OpenAI',
    'Facebook',
    'Microsoft',
    'Linkedin',
    'Amazon',
  ],
  'security-engineering-interviews': [
    'Anthropic',
    'Google',
    'Amazon',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Apple',
    'Linkedin',
  ],
  'solution-architect-interview': [
    'Anthropic',
    'Amazon',
    'Google',
    'OpenAI',
    'Microsoft',
    'Facebook',
    'Linkedin',
    'Uber',
  ],
  'system-design-interview': [
    'Anthropic',
    'Google',
    'Facebook',
    'OpenAI',
    'Amazon',
    'Microsoft',
    'Linkedin',
    'Uber',
  ],
};
